import sample_1 from './100_73403.jpg';
import sample_2 from './100_73478.jpg';

export const peakImpressions = {
    sample_2,
    sample_1,
};
